import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import useUniqueId from 'hooks/useUniqueId';
import Modal from 'components/Modal';
import { ConfirmationModal } from 'screens/ContentEditorModals';
import { getIsActiveTabFromParams } from 'utils/content/getIsActiveTabFromParams';
import { getTabLinkFromParams } from 'utils/content/getTabLinkFromParams';
import SingleAssetManager from './SingleAssetManager';
import MultiAssetManager from './MultiAssetManager';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AssetManager(_ref) {
  var inContentManagerContext = _ref.inContentManagerContext,
    hasOpenOption = _ref.hasOpenOption,
    assets = _ref.assets,
    parentPlaylist = _ref.parentPlaylist,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit;
  var titleId = useUniqueId();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasChanges = _useState2[0],
    setHasChanges = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasConfirmationModal = _useState4[0],
    setHasConfirmationModal = _useState4[1];
  function handleClose() {
    if (hasChanges) {
      setHasConfirmationModal(true);
    } else {
      onClose();
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Modal, {
      "aria-labelledby": titleId,
      onRequestClose: handleClose,
      layout: "top-aligned",
      width: "extraWide",
      children: assets.length === 1 ? /*#__PURE__*/_jsx(SingleAssetManager, {
        inContentManagerContext: inContentManagerContext,
        hasOpenOption: hasOpenOption,
        titleId: titleId,
        asset: assets[0],
        parentPlaylist: parentPlaylist,
        setHasChanges: setHasChanges,
        onClose: handleClose,
        onSubmit: onSubmit,
        getIsActiveTab: getIsActiveTabFromParams,
        getTabLink: getTabLinkFromParams
      }) : /*#__PURE__*/_jsx(MultiAssetManager, {
        titleId: titleId,
        assets: assets,
        parentPlaylistId: parentPlaylist === null || parentPlaylist === void 0 ? void 0 : parentPlaylist.id,
        onClose: onClose,
        onSubmit: onSubmit,
        getIsActiveTab: getIsActiveTabFromParams,
        getTabLink: getTabLinkFromParams
      })
    }), hasConfirmationModal && /*#__PURE__*/_jsx(ConfirmationModal, {
      isEditMode: true,
      isLoading: false,
      onConfirm: function onConfirm() {
        setHasConfirmationModal(false);
        onClose();
      },
      onCancel: function onCancel() {
        return setHasConfirmationModal(false);
      }
    })]
  });
}
export default AssetManager;
export { ShareMultiContentOption } from './MultiAssetManager/MultiAssetHeader';
export { useGetTabInfo } from './useGetTabInfo';